import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'

import '@/styles/theme.scss';

Vue.config.productionTip = false

import breakpoints from '@/helpers/breakpoints'
Vue.use(breakpoints)

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, numeric } from 'vee-validate/dist/rules';
extend('email', email);
extend('numeric', numeric);
extend('required', required);
// Add a rule.

import FeatherWrapper from 'vue-feather-icons-wrapper'
Vue.use(FeatherWrapper)


// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  duration: 1000
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
